import React, {Fragment} from "react";
import ModalConfirm from "../../../components/ModalConfirm";
import ModalMsg from "../../../components/ModalMsg";
import Sidebar from "../../../components/Sidebar";
import NsAccordion from "../../../components/accordion/NsAccordion";
import NsDataTable from "../../../components/tabelle/NsDataTable";

export default function ConfTipoImpExpDatiView({
                                                   showConfirm,
                                                   setShowConfirm,
                                                   eliminaElemento,
                                                   translate,
                                                   show,
                                                   setShow,
                                                   tipoSel,
                                                   modalMsg,
                                                   isMobile,
                                                   loadingData,
                                                   getAlberoStruttura,
                                                   tipiImpExp,
                                               }) {

    return (
        <Fragment>
            <ModalConfirm
                show={showConfirm}
                handleClose={() => setShowConfirm(false)}
                handleOk={eliminaElemento}
                testo={translate("Sicuro di voler eliminare il tipo: ") + (tipoSel && (tipoSel.descrizione)) + "?"}/>
            <ModalMsg
                show={show}
                handleClose={() => setShow(false)}
                testo={modalMsg}/>
            {
                !loadingData &&
                <Fragment>
                    <Sidebar
                        sidebarContent={() => {
                            return isMobile ?
                                <NsAccordion
                                    titolo={'Struttura tipiImpExp'}
                                    label={'fas fa-stream'}>
                                    {
                                        getAlberoStruttura()
                                    }
                                </NsAccordion>
                                : getAlberoStruttura()
                        }}
                    >
                        <NsDataTable
                            data={tipiImpExp}
                            columns={[
                                {
                                    name: translate('Codice'),
                                    selector: row => row.codice,
                                    sortable: true
                                },
                                {
                                    name: translate('Descrizione'),
                                    selector: row => row.descrizione,
                                    sortable: true
                                },
                                {
                                    name: translate('Classe'),
                                    selector: row => row.classe_tipo_imp_exp,
                                    sortable: true
                                },
                            ]}
                            addFiltri={false}
                        >
                        </NsDataTable>
                    </Sidebar>
                </Fragment>
            }
        </Fragment>
    );
}
